import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';

/**
 * Get a list of CoPilot app versions available in the account,
 * as well as the numer of assets with each version.
 * @returns Array of app version strings
 */
export function getCompanyAppversionV2(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(accountsEnvironment.resolve(this).companyAppversionV2Url, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(
    selectData(
      z.array(
        z.object({ appVersion: z.string().nullable(), count: z.number() })
      )
    )
  );
}
